import React from 'react';

import { components } from 'react-select';

import { Icon } from '../icons';

export const MultiValueRemove = (props) => {
  // Options marked isFixed cannot be removed (e.g. linked incidents the
  // viewer has no access to), so they get no remove button.
  if (props.data?.isFixed) {
    return null;
  }

  return (
    <components.MultiValueRemove {...props}>
      <Icon height="14px" width="14px" name="close" />
    </components.MultiValueRemove>
  );
};
